import { FieldErrors, FieldValues } from "react-hook-form";

export function getFirstErrorPath<T extends FieldValues>(errors: FieldErrors<T>, prefix = ""): string | null {
  for (const key in errors) {
    const value = errors[key];
    const path = prefix ? `${prefix}.${key}` : key;

    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        const item = value[i];
        if (item && typeof item === "object" && Object.keys(item).length > 0) {
          const nested = getFirstErrorPath(item as FieldErrors<T>, `${path}.${i}`);
          if (nested) return nested;
        }
      }
    } else if (value && typeof value === "object") {
      if ("message" in value && "type" in value) {
        return path;
      } else {
        const nested = getFirstErrorPath(value as FieldErrors<T>, path);
        if (nested) return nested;
      }
    }
  }

  return null;
}
